import { ApplicationAuthManager } from "warded-lock/dist";

let userManager: ApplicationAuthManager | null = null;

export function getAuthenticationManager(): ApplicationAuthManager {
    if (userManager === null) {
        userManager = new ApplicationAuthManager({
            authority: process.env.REACT_APP_AUTHORITY,
            clientId: process.env.REACT_APP_CLIENT_ID,
            redirectUrl: process.env.REACT_APP_REDIRECT_URI,
            verbose: false,
            exculdedPaths: ["/login"],
        });

        return userManager;
    }

    return userManager;
}
